import { render, staticRenderFns } from "./unit-reliability.vue?vue&type=template&id=0c10bacc&scoped=true"
import script from "./unit-reliability.ts?vue&type=script&lang=js&external"
export * from "./unit-reliability.ts?vue&type=script&lang=js&external"
import style0 from "./unit-reliability.vue?vue&type=style&index=0&id=0c10bacc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c10bacc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c10bacc')) {
      api.createRecord('0c10bacc', component.options)
    } else {
      api.reload('0c10bacc', component.options)
    }
    module.hot.accept("./unit-reliability.vue?vue&type=template&id=0c10bacc&scoped=true", function () {
      api.rerender('0c10bacc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/uni-reliability/unit-reliability.vue"
export default component.exports